document.addEventListener("DOMContentLoaded", function() {
  // Seleccionamos todos los labels con la clase "color-swatch"
  const labels = document.querySelectorAll('label.color-swatch');

  labels.forEach(label => {
    label.addEventListener('click', function() {
      // Obtener el color del atributo "data-color" del label
      const color = label.getAttribute('data-color');

      // Encontrar la primera sección padre
      const parentSection = label.closest('section');

      // Si se encuentra una sección padre
      if (parentSection) {
        // Cambiar el color de fondo de la sección
        parentSection.style.backgroundColor = color;

        // Seleccionar el botón con la clase "product-form__submit" dentro de esta sección
        const submitButton = parentSection.querySelector('.product-form__submit');

        // Cambiar el color del texto del botón si existe
        if (submitButton) {
          submitButton.style.color = color;
        }

        // Encontrar el primer div con la clase "featured-product"
        const featuredProduct = parentSection.querySelector('.featured-product');

        if (featuredProduct) {
          // Si el color es "#F9D148", agregar la clase "dark-button"
          if (color === '#F9D148') {
            featuredProduct.classList.add('dark-button');            
          } else {
            featuredProduct.classList.remove('dark-button');            
          }

          if ( color === '#ffffff') {
            featuredProduct.classList.add('dark-button-white');      
            
          } else {                        
            featuredProduct.classList.remove('dark-button-white');
            
             
          }

        }
      }
    });
  });

  // Seleccionar todos los elementos <select> e inputs de tipo "radio"
  const elements = document.querySelectorAll('select, input[type="radio"]');

  elements.forEach(function(element) {
    element.addEventListener('change', function() {
      // Obtener la posición actual del scroll
      const currentPos = window.scrollY;

      // Establecer la posición del scroll para evitar el desplazamiento
      window.scrollTo(0, currentPos);
    });
  });
});
